import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Shows the Team Plan upgrade prompt before applying dynamic_forward.
 */
export function useDynamicForwardUpgrade() {
  const navigate = useNavigate();
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  const requestUpgrade = useCallback(() => {
    setUpgradeOpen(true);
  }, []);

  const goToBilling = useCallback(() => {
    setUpgradeOpen(false);
    navigate("/dashboard/settings/billing");
  }, [navigate]);

  const cancelUpgrade = useCallback(() => {
    setUpgradeOpen(false);
  }, []);

  return {
    requestUpgrade,
    upgradeOpen,
    goToBilling,
    cancelUpgrade,
  };
}
